import { SignatureStore } from './schema/SignatureStore';
import { createStore } from 'satcheljs';

const signatureStore: SignatureStore = {
    roamingHtmlSignature: null,
    roamingTxtSignature: null,
};

export const getStore = createStore<SignatureStore>('signature', signatureStore);

export const store = getStore();
